import axios from '../../common/axios.js'
import Loading from '../loading.vue'
import _ from 'lodash'
import Input from '../../common/forms/Input.vue'
import Select from '../../common/forms/Select.vue'
import LoadingBtn from '../../common/ui/loading_btn.vue'
import ContentEditable from '../../common/forms/ContentEditable.vue'
import MultiSelect from '../../common/forms/MultiSelect.vue'


export default {
	data(){
		return {
			country: 'FRA',
			// id_national: '75209460700021',
			// id_national: '42855996702962',
			id_national: '',
			id_national_check: false,
			naf_code: '',
			name: '',
			web: '',
			address: '',
			address_2: '',
			zip_code: '',
			city: '',
			activity: '',
			activity_capacity: '',
			activity_quantity_minimum_test: '',
			secondary_activities: '',
			secondary_activities_capacity: '',
			secondary_activities_quantity_minimum_test: '',
			tertiary_activities: '',
			tertiary_activities_capacity: '',
			tertiary_activities_quantity_minimum_test: '',
			expertise_motivation: '',
			how_meet_recycle: 'recherche',
			is_recycled_waste_user: null,
			other_value: '',
			competence_selected: '',
			competences: [],
			check_nl: false,
			check_cgu: false,
			open_cgu: false,
			error: false,
			errors: [],
			expired: false,
			editable: false,
			message_erreur: 'connection_erreur',
			loading: false,
			loading_check_id_national: false,
			success: false,
			capacites: {},
			signin_user: '',
			countries: [],
		}
	},
	created(){
		// Récupération des pays
		axios.get('api=inex/nomenclatures/countries').then((response) => {
			this.countries = response.data;
		});

		// Récupération de l'email de l'utilisateur connecté
		axios.get('/plugin_projet/plugin_projet_iannuaire/get_signin_user').then((response) => {
			if(response.data){
				this.signin_user = response.data;
			}else{
				this.$store.commit('UI_SET_MODAL', {modal: 'signin'});
			}
		});
	},
	watch: {
		id_national(newVal){
			// Vérification du format du numéro de siret
			this.id_national = newVal.trim()
		},
		competence_selected(newVal){
			// Ajout ou suppression d'une compétence
			if(newVal){
				if(!this.competences.includes(newVal)){
					this.competences.push(newVal);
				}else{
					this.competences = this.competences.filter(competence => competence != newVal);
				}
				this.competence_selected = '';
			}
		}
	},
	methods:{
		reset_id_national(){
			this.id_national = '';
			this.id_national_check = false;
			this.editable = false;
			this.errors = {};
			this.activity = '';
			this.naf_code = '';
			this.name = '';
			this.web = '';
			this.address = '';
			this.address_2 = '';
			this.zip_code = '';
			this.city = '';
			this.competences = [];
			this.capacites = {};
		},
		check_id_national(){		
			let self = this;
			this.id_national_check = false;
			this.loading_check_id_national = true;
			// Vérification du numéro de siret par l'API 
			axios.get('api=inex/companies/inscriptions/'+this.id_national).then((response) => {
				if(response.data){			
					// Récupération des données de l'entreprise
					self.editable = response.data.editable;
					self.id_national_check = true;
					self.naf_code = response.data.naf_code != null ? response.data.naf_code : '';
					self.name = response.data.name != null ? response.data.name : '';
					self.web = response.data.web != null ? response.data.web : '';
					self.address = response.data.address != null ? response.data.address : '';
					self.address_2 = response.data.address_2 != null ? response.data.address_2 : '';
					self.zip_code = response.data.zip_code != null ? response.data.zip_code : '';
					self.city = response.data.city != null ? response.data.city : '';
					self.competences = response.data.competences_ids != null ? response.data.competences_ids : [];
					self.activity = response.data.famille_id != null ? response.data.famille_id : '';
					self.capacites = response.data.capacites != null ? response.data.capacites : {};
					self.secondary_activities = response.data.familles_secondaires_ids[0] != null ? response.data.familles_secondaires_ids[0] : '';
					self.tertiary_activities = response.data.familles_secondaires_ids[1] != null ? response.data.familles_secondaires_ids[1] : '';
				}else{
					self.editable = true;
				}
			}).catch((error) => {
				console.log(error);
			}).finally(() => {
				this.id_national_check = true;
				this.loading_check_id_national = false;
			})
		},
		send_inscription(){
			this.errors = {};

			// Récupération des capacités de l'entreprise
			let main_capacites = this.getFamilleCapacties(this.activity);
			let all_capacites = this.getFamilleCapacties(this.activity);
			all_capacites.push(...this.getFamilleCapacties(this.secondary_activities));
			all_capacites.push(...this.getFamilleCapacties(this.tertiary_activities));

			// Vérification des champs obligatoires
			if(this.expertise_motivation == ''){
				this.errors.expertise_motivation = this.$t('signin_company_error_expertise_motivation');
			}
			if(this.how_meet_recycle == 'autre' && this.other_value == ''){
				this.errors.other_value = this.$t('signin_company_error_other_value');
			}
			// if(this.check_nl == false){
			// 	this.errors.check_nl = this.$t('signin_company_error_check_nl');
			// }
			if(this.check_cgu == false){
				this.errors.check_cgu = this.$t('signin_company_error_check_cgu');
			}
			if(this.is_recycled_waste_user == null){
				this.errors.is_recycled_waste_user = this.$t('signin_company_error_is_recycled_waste_user');
			}

			// Vérification des capacités
			main_capacites.forEach(capacite => {
				console.log('==> ', capacite, this.capacites);
				
				if(capacite.obligatoire && this.capacites[capacite.id] == null || this.capacites[capacite.id] == ''){
					if(!this.errors.capacites){
						this.errors.capacites = {};
					}
					this.errors.capacites[capacite.id] = this.$t('signin_company_error_capacite_obligatoire');
				}
			});

			// Vérification des capacités numériques
			all_capacites.forEach(capacite => {
				if(capacite.fonctionnement == 'numeric' && this.capacites[capacite.id]){
					this.capacites[capacite.id] = this.capacites[capacite.id].trim();
					this.capacites[capacite.id] = this.capacites[capacite.id].replace(/,/g, '.');
					if(isNaN(this.capacites[capacite.id])){
						if(!this.errors.capacites){
							this.errors.capacites = {};
						}
						this.errors.capacites[capacite.id] = this.$t('signin_company_error_capacite_obligatoire_format_numeric');
					}
				}
			});

			if(this.editable){
				
				if(this.name == '' ){
					this.errors.name = this.$t('signin_company_error_name');
				}
				if(this.address == '' ){
					this.errors.address = this.$t('signin_company_error_address');
				}
				if(this.zip_code == '' ){
					this.errors.zip_code = this.$t('signin_company_error_zip_code');
				}
				if(this.city == '' ){
					this.errors.city = this.$t('signin_company_error_city');
				}
				if(this.activity == '' ){
					this.errors.activity = this.$t('signin_company_error_activity');
				}
				// Vérification du code NAF 
				this.naf_code = this.naf_code.trim();
				this.naf_code = this.naf_code.toUpperCase();
				this.naf_code = this.naf_code.replace(/\./g, '');
				if(this.naf_code == ''){
					this.errors.naf_code = this.$t('signin_company_error_naf_code');

				// Vérification du format du code NAF
				}else if(this.naf_code.length != 5 || !/^(|\d{4}[A-Z])$/.test(this.naf_code)){
					this.errors.naf_code = this.$t('signin_company_error_naf_code_format');
				}

			}

			if(Object.keys(this.errors).length > 0){
				return;
			}
			
			// Nettoyage des capacités
			let clean_capacites = {};
			all_capacites.forEach(capacite => {
				clean_capacites[capacite.id] = this.capacites[capacite.id] || '';
			});

			let familles_secondaires_ids = [];
			if(this.secondary_activities){
				familles_secondaires_ids.push(this.secondary_activities);
			}
			if(this.tertiary_activities){
				familles_secondaires_ids.push(this.tertiary_activities);
			}

			let data = {
				country: this.country,
				naf_code: this.naf_code,
				name: this.name,
				web: this.web,
				address: this.address,
				address_2: this.address_2,
				zip_code: this.zip_code,
				city: this.city,
				famille_id: this.activity,
				familles_secondaires_ids: familles_secondaires_ids,
				competences_ids: this.competences,
				capacites_ids: clean_capacites,
			}
						
			this.loading = true;
			let save_company = false;
			axios.post('api=inex/companies/inscriptions/'+this.id_national, data).then((response) => {				
				save_company = true;
			}).catch((error) => {
				if(error.response.status == 409){
					save_company = true;
				}

				if(error.response.status == 422){
					//RZ--> Si le code NAF n'existe pas, on affiche un message d'erreur
					if(error.response.data?.detail?.length > 0 && Array.isArray(error.response.data.detail)){
						error.response.data.detail.forEach(detail => {
							if(/code_naf/.test(detail.msg)){
								this.errors.naf_code = this.$t('signin_company_error_naf_code_not_exist');
							}
						});
					}

					if(typeof error.response.data?.detail == 'string'){
						//RZ--> Si le message d'erreur est une chaîne de caractères et contient le texte 'Geocoding'
						if(/Geocoding/.test(error.response.data.detail)){
							this.errors.geoloc = this.$t('signin_company_error_address_not_exist');
						}
					}
				}
			}).finally(() => {
				if(save_company){
					let signin_mail = this.signin_user;
					let user_data = {
						how_meet_recycle: this.how_meet_recycle,
						is_recycled_waste_user: this.is_recycled_waste_user == 'oui' ? true : false,
						expertise_motivation: this.expertise_motivation,
						other_expertise_motivation: '',
					}

					if(this.how_meet_recycle == 'autre'){
						user_data.other_expertise_motivation = this.other_value;
					}

					// Enregistrement de l'utilisateur dans la base de données inex
					axios.post('api=inex/users/'+signin_mail+'/'+this.id_national, user_data).then((response) => {
					}).catch((error) => {
						console.log('==> ', error);
					}).finally(() => {
						// Enregistrement de l'entreprise dans la base de données iannuaire
						axios.get('/plugin_projet/plugin_projet_iannuaire/company_signin').then((response) => {
							// Redirection vers la page de connexion
							this.$store.commit('UI_SET_MODAL', {modal: 'signin_success'});
						}).catch((error) => {
							console.log('==> ', error);
						}).finally(() => {
							this.loading = false;
						})
						this.loading = false;
					})
				}else{
					this.loading = false;
				}
			})
		},
		go_to_connection(){
			history.pushState({}, '', window.location.pathname);
			this.$store.commit('UI_SET_MODAL', { modal: 'connection' });
		},
		go_to_recupass(){
			history.pushState({}, '', window.location.pathname);
			this.$store.commit('UI_SET_MODAL', { modal: 'password' });			
		},
		removeCompetence(_competence){
			this.competences = this.competences.filter(competence => competence != _competence);
		},
		openCgu(){
			let url = "https://pro.refashion.fr/conditions-generales-dutilisation";
			window.open(url, '_blank');
		},
		get_competence_label(competence_id){
			let competences = this.competences_options;
			let competence = competences.find(competence => competence.value == competence_id);
			return competence ? competence.label : '';
		},
		getFamilleCapacties(famille_id){
			let self = this;
			let capacites = [];
			let famille = self.$store.state.ui.sourcing.familles.find(famille => famille.id == famille_id);
			
			if(famille?.capacites_ids && famille.capacites_ids.length > 0){
				famille.capacites_ids.forEach(capacite_id => {
					let capacite = self.$store.state.ui.sourcing.capacites_all[capacite_id];
					capacite.id = capacite_id;
					capacites.push(capacite);
				});
			}
			return capacites;
		}
	},
	computed: {
		show_id_national_example(){
			return !this.check_id_national_btn && !this.id_national_check && this.id_national.length > 0
		},
		check_id_national_btn(){
			return this.country == 'FRA' && /^\d{14}$/.test(this.id_national) || this.country != 'FRA' && this.id_national.length >= 5;
		},
		country_options(){
			return this.countries;
		},
		id_national_label(){
			return this.country == 'FRA' ? this.$t('signin_company_label_id_national') : this.$t('signin_company_label_id_national_tva') 
		},
		id_national_label_example(){
			return this.country == 'FRA' ? this.$t('signin_company_label_id_national_example') : this.$t('signin_company_label_id_national_example_tva') 
		},
		activites_options(){
			let self = this
			let activites = _.sortBy(_.cloneDeep(this.$store.state.ui.sourcing.familles), ['ordre']);
		
			activites = activites.map(activite => ({label: activite.titre, value: activite.id}));
			if (activites.length > 0) {
				activites.shift();
			}

			activites = activites.map(function(activite){
				if(self.activity == activite.value){
					activite.disabled = true;
				}
				if(self.secondary_activities == activite.value){
					activite.disabled = true;
				}
				if(self.tertiary_activities == activite.value){
					activite.disabled = true;
				}
				return activite
			});
			return activites;
		},
		how_meet_recycle_options(){
			return [
				{label: this.$t('signin_company_how_meet_recycle_deja_lie_a_refashion'), value: 'deja_lie_a_refashion'},
				{label: this.$t('signin_company_how_meet_recycle_moteur_de_recherche_reseaux_sociaux'), value: 'recherche'},
				{label: this.$t('signin_company_how_meet_recycle_evenement'), value: 'evenement'},
				{label: this.$t('signin_company_how_meet_recycle_bouche_a_oreille'), value: 'bouche_a_oreille'},
				{label: this.$t('signin_company_how_meet_recycle_autre'), value: 'autre'},
			]
		},
		competences_options(){
			let competences = _.cloneDeep(this.$store.state.ui.competences);
			
			competences = competences.map(competence => ({label: competence.nom, value: competence.id, disabled: this.competences.includes(competence.id)}));
			return competences;
		},
		showCgu(){
			return this.$t('signin_company_text_cgu')
		},
		
	},
	components: {
		Input,
		Select,
		LoadingBtn,
		ContentEditable,
		MultiSelect,
		Loading
	}
}
